// import Bowser from "bowser";

// Item code and barcode are both optional on an item, so this only appends
// each one when actually present -- mirrors the backend's display_text
// CONCAT(...IF(...)) convention (see administration.js's getItemsBySearch
// and the item-search queries in sales.js/purchase.js/etc.) so the item
// search dropdown and the selected-item field always show the same full
// name, whether the item list came from the server or was built locally.
export const getItemDisplayName = (item) => {
  if (!item) return "";
  const parts = [item.item_name];
  if (item.item_code) parts.push(item.item_code);
  if (item.item_barcode) parts.push(item.item_barcode);
  return parts.filter(Boolean).join(" - ");
};

export const getAddress = async (lat, lng) => {
  const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${API_KEY}`;

  try {
    const response = await fetch(url);
    const data = await response.json();
    if (data.status === "OK") {
      return data.results[0]?.formatted_address || "Address not found";
    } else {
      throw new Error("Unable to fetch address");
    }
  } catch (err) {
    throw new Error("Error fetching address: " + err.message);
  }
};

export const convertCurrency = async (fromCurrency, toCurrency) => {
  const API_KEY = process.env.REACT_APP_EXCHANGE_RATE_API_KEY;
  const url = `https://v6.exchangerate-api.com/v6/${API_KEY}/pair/${fromCurrency}/${toCurrency}`;
  try {
    const response = await fetch(url);
    const rate = await response.json();

    return rate.conversion_rate;
  } catch (error) {
    console.error("Currency conversion error:", error.message);
    return null;
  }
};

// export const getLocation = () => {
//   return new Promise((resolve, reject) => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const payload = {
//             latitude: position.coords.latitude,
//             longitude: position.coords.longitude,
//           };
//           resolve(payload); // Resolve the promise with the location data
//         },
//         (error) => {
//           reject(error.message); // Reject the promise with the error message
//         }
//       );
//     } else {
//       reject("Geolocation is not supported by this browser.");
//     }
//   });
// };

export const getClientDetails = async () => {
  //   const browser = Bowser.getParser(window.navigator.userAgent);
  //   const result = browser.parse();
  //const location = await getLocation();

  const address = "Suite 997 45333 Schroeder Pines, Wizaside, WY 18169-7157";

  const clientDetails = {
    browser: "chrome", // e.g., "Chrome"
    os: "windows", // e.g., "Windows", "iOS"
    deviceType: "Desktop", // e.g., "Mobile", "Tablet", "Desktop"
    deviceModel: "Unknown", // e.g., "iPhone"
    deviceVendor: "Unknown", // e.g., "Apple"
    screenResolution: `${window.screen.width}x${window.screen.height}`, // Screen size
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, // e.g., "America/New_York"
    language: navigator.language, // e.g., "en-US"
    address, // IP Address
  };

  return clientDetails;
};
